import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from 'react-query'

import { msalConfig } from 'config/authentication.config'
import Login from 'views/Login'
import App from 'views/App'

import 'shared/styles/main.less'

import 'locales/i18n'

const msalInstance = new PublicClientApplication(msalConfig)
const queryClient = new QueryClient()

ReactDOM.render(
    <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Switch>
                    <Route component={Login} path="/login" />
                    <Route component={App} path="/" />
                </Switch>
            </BrowserRouter>
        </QueryClientProvider>
    </MsalProvider>,
    document.getElementById('root')
)
